module.exports = __webpack_public_path__ + "img/road-a.c36ca553.png";